import React from "react";
import classes from "./ClientsListLetterNavigation.module.css"
import useTheme from "../../../../common/hooks/useTheme";

type Props = {
  /** Scrolls the list to the letter (the list picks the nearest one with
   *  clients): the rows are virtualized, so there is no element to scroll to. */
  onSelectLetter: (letter: string) => void;
};

const ClientsListLetterNavigation = ({ onSelectLetter }: Props) => {
  const theme = useTheme();

  return (
    <div className={classes.container}>
        {['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'].map((letter, index) => (
        <div 
            key={index} 
            className={classes.item} 
            style={{ color: theme.colors_ds.PRIMARY_TEXT_MAIN }}
            onClick={() => onSelectLetter(letter)}
        > 
            {letter} 
        </div>
        ))} 
    </div>
  );
};

export default ClientsListLetterNavigation;